import type { ReactNode } from 'react';
import { Footer } from './Footer';
import { Header } from './Header';

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-surface">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
